const AT = require("./ActionTypes");
const PageShared = require("../../../shared/PageShared");
const OpsUser = require("./OpsUser");

const onNavigateWhenDisconnected = function(vault, page, href) {
	const state = vault.getState();
	if (state.connected) {
		const user = vault.state.user;
		if (
			PageShared.isTrainerPage(page) &&
			!OpsUser.hasTrainerPermission(user) &&
			!page.demo
		) {
			vault.dispatch({
				type: AT.SHOW_MESSAGE,
				messageType: "noTrainerPermission",
				data: {userRoles: OpsUser.getUserRoles(user)},
			});
			return false;
		}

		return true;
	} else if (page.name === "trainer.problem") {
		vault.dispatch({
			type: AT.SHOW_MESSAGE,
			messageType: "disconnected",
		});
		return false;
	}
	return true;
};

const setupURLHooks = function(router) {
	router.addURLHook(onNavigateWhenDisconnected);
};

module.exports = {
	setup: setupURLHooks,
};
